<template>
  <div class="login-module">
    <div class="login-tab">
      <div class="close-btn" @click="close">
        <span
          class="iconfont icon-a-CombinedShape4"
          style="font-size: 12px"
        ></span>
      </div>
      <p class="login-textc">手机验证</p>
      <p class="login-texte">PHONE CODE</p>
      <el-form :model="editForm" label-width="100px" ref="editForm">
        <div class="login-input">
          <div class="phoneinput">
            <div class="phone">
              <img src="../../assets/images/wangji.png" alt />
            </div>
            <div class="b-input">
              <div class="codeinput">
                <el-form-item type="primary">
                  <el-input
                    placeholder="请输入验证码"
                    @input="disabledcodeClick"
                    maxlength="4"
                    v-model="editForm.code"
                  ></el-input>
                </el-form-item>
                <div class="errorhint" v-show="errorhintCode">
                  {{ errorhinttextCode }}
                </div>
              </div>

              <div class="codebtn">
                <el-button
                  type="primary"
                  :class="[
                    disabled == false
                      ? 'el-button--primary'
                      : 'el-button--primaryno',
                  ]"
                  :disabled="disabled"
                  @click="verification"
                  >{{ btntxt }}</el-button
                >
              </div>
            </div>
          </div>
          <div class="register">
            <el-button
              type="primary"
              :class="[
                nextdisabled == false
                  ? 'el-button--primary'
                  : 'el-button--primaryno',
              ]"
              :disabled="nextdisabled"
              @click.native.prevent="nextstepClick"
              >确定</el-button
            >
          </div>
        </div>
      </el-form>
      <transition name="plus-icon">
        <HintPrompt :markedwords="markedwords" v-show="hintpromptstate" />
      </transition>
    </div>
  </div>
</template>

<script>
import HintPrompt from "@/components/wx-hintprompt";
import { ForgetPasswordCode, ForgetPassCode, isUse } from "@/api/login";
export default {
  components: { HintPrompt },
  // props: {
  //   loginparameters: {
  //     type: Object,
  //     default: () => {},
  //   },
  // },
  data() {
    return {
      timeout: null,
      timeouta: null,
      hintpromptstate: false, //提示框状态
      markedwords: "", //提示框文字
      errorhintCode: false,
      errorhinttextCode: "",
      editForm: {
        username: "15811155833", // 15811155833
        code: "",
      },
      nextdisabled: true, //下一步颜色
      disabled: false, //灰色
      time: 0, //验证码时间

      btntxt: "获取验证码",
      // logindata: this.loginparameters,
    };
  },
  computed: {},
  methods: {
    //手机号 验证码输入判断
    disabledcodeClick() {
      //下一步按钮判断
      if (this.editForm.code != "" && this.editForm.username != "") {
        this.nextdisabled = false;
      } else {
        this.nextdisabled = true;
      }
      let phoneInt = /^1[3456789]\d{9}$/;
      let captcha = /^\d{4}$/;
      //验证码按钮判断
      if (this.editForm.username != "") {
        if (this.time == 0) {
          this.disabled = false;
        }
      } else {
        this.disabled = true;
      }
    },
    nextstepClick() {
      //验证注册账号
      let phoneInt = /^1[3456789]\d{9}$/;
      let captcha = /^\d{4}$/;
      if (this.editForm.code == "") {
        this.errorhintCode = true;
        this.errorhinttextCode = "请输入验证码";
      } else if (captcha.test(this.editForm.code) == false) {
        this.errorhintCode = true;
        this.errorhinttextCode = "验证码格式错误";
      } else {
        ForgetPasswordCode(this.editForm).then((res) => {
          if (res.code === 200) {
            // this.logindata.settingUsername = this.editForm.username;
            // this.logindata.settingCode = this.editForm.code;
            // this.logindata.settingdata = true;
            this.editForm.username = "";
            this.editForm.code = "";
            this.disabled = true; //验证码颜色
            this.nextdisabled = true; //下一步颜色
            this.$emit("getLogin");
          } else if (res.code === 3000) {
            this.errorhintCode = true;
            this.errorhinttextCode = "验证码错误";
          }
        });
      }
    },
    verification() {
      isUse(this.editForm.username).then((res) => {
        if (res.data == 1) {
          ForgetPassCode(this.editForm.username).then((res) => {
            if (res.code === 200) {
              this.time = 60;
              this.disabled = true;
              this.hintpromptstate = true;
              this.markedwords = "验证码发送成功";
              this.timeout = setTimeout(() => {
                this.hintpromptstate = false;
              }, 1000);
              this.errorhintCode = false;
              this.errorhint = false;
              this.timer();
            }
          });
        }
      });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s";
        this.timeouta = setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        let phoneInt = /^1[3456789]\d{9}$/;
        if (
          this.editForm.username != "" &&
          phoneInt.test(this.editForm.username) == true
        ) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
    },
    close() {
      // this.$store.commit('loginState', false);
      // this.logindata.logindata = true;
      // this.logindata.forgetdata = false;
      // this.logindata.settingdata = false;
      // this.logindata.codedata = false;
      this.$emit("esc");
    },
  },
  beforeDestroy(){
    clearTimeout(timeout);
    clearTimeout(timeouta);
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped >
@import './index.styl';
</style>



// WEBPACK FOOTER //
// src/components/wx-forgetphonecode/index.vue